(function () {

var CANDLES = [
  { id:"bundle-gelatopia",  title:"Bundle Gelatopia",             handle:"bundle-gelatopia",                       variantId:46627046031559, price:"104,00 $", img:"https://cdn.shopify.com/s/files/1/0567/8193/0695/files/C89CBAB3-7ACE-47D4-93A9-B6990C1EA5ED.png?v=1780729661",   tags:{ambiance:["celebrer","energiser"],      notes:["fruitee","fraiche"],           saison:["terrasse_ete"],              perso:["party_animal"]} },
  { id:"pina-colada",       title:"Pi\u00f1a Colada x Choco Favoris",  handle:"pina-colada-chocolats-favoris-x-ok-bye", variantId:46593812398279, price:"24,00 $",  img:"https://cdn.shopify.com/s/files/1/0567/8193/0695/files/C5817734-5476-45B8-851B-8E1160C23FB4.png?v=1779666193",  tags:{ambiance:["celebrer","energiser"],      notes:["fruitee","gourmande"],         saison:["terrasse_ete"],              perso:["party_animal","creative"]} },
  { id:"mangue-passion",    title:"Mangue & Fruit de la passion",  handle:"mangue-fruit-de-la-passion",             variantId:45175534518471, price:"24,00 $",  img:"https://cdn.shopify.com/s/files/1/0567/8193/0695/files/0899C245-3A47-4E67-85C4-6268178195A3.jpg?v=1749514125",  tags:{ambiance:["energiser","seduire"],       notes:["fruitee","fraiche"],           saison:["terrasse_ete"],              perso:["party_animal","romantique"]} },
  { id:"lime-coco",         title:"Lime & Noix de coco",           handle:"cocktail-o-clock",                       variantId:42421997404359, price:"24,00 $",  img:"https://cdn.shopify.com/s/files/1/0567/8193/0695/files/4315D4E0-A94F-460C-BC07-DF91044BD48C.jpg?v=1749515769",  tags:{ambiance:["celebrer","energiser"],      notes:["fraiche","fruitee"],           saison:["terrasse_ete"],              perso:["party_animal","fan_plein_air"]} },
  { id:"fraise-basilic",    title:"Fraise des bois & Basilic",     handle:"fraise-des-bois-basilic",                variantId:45175502012615, price:"24,00 $",  img:"https://cdn.shopify.com/s/files/1/0567/8193/0695/files/72C7E8D6-13FE-426C-8DA9-FEB25B520E6F.jpg?v=1749515405",  tags:{ambiance:["energiser","se_detendre"],   notes:["fruitee","fraiche","florale"], saison:["fleurs_printemps","terrasse_ete"], perso:["creative","fan_plein_air"]} },
  { id:"pistache-caramel",  title:"Pistache & Caramel sal\u00e9",      handle:"pistache-caramel-sale",                  variantId:45175516364999, price:"24,00 $",  img:"https://cdn.shopify.com/s/files/1/0567/8193/0695/files/F6EB8CF5-51C0-4F29-9A61-B8224F3B3656.jpg?v=1749515282",  tags:{ambiance:["se_detendre","celebrer"],    notes:["gourmande"],                   saison:["terrasse_ete"],              perso:["creative","party_animal"]} },
  { id:"figues-sucre-brun", title:"Figues & Sucre brun",           handle:"figues-sucre-brun-og-version",           variantId:46450638782663, price:"42,00 $",  img:"https://cdn.shopify.com/s/files/1/0567/8193/0695/files/B5DEA3F0-84EC-428D-8FB8-A7AAA96CF2FA.webp?v=1777059431", tags:{ambiance:["se_detendre","seduire"],     notes:["florale","gourmande"],         saison:["fleurs_printemps","pluie_automne"], perso:["romantique","creative"]} },
  { id:"rose-vanille",      title:"Rose & Vanille",                handle:"bougie-mystere-saint-valentin",          variantId:46276306108615, price:"42,00 $",  img:"https://cdn.shopify.com/s/files/1/0567/8193/0695/files/6E9D1383-EB5A-4762-BD4B-B685551C47EE.jpg?v=1767405425",  tags:{ambiance:["seduire","se_detendre"],    notes:["florale","sensuelle"],         saison:["fleurs_printemps"],          perso:["romantique"]} },
  { id:"suede-pin",         title:"Su\u00e8de & Pomme de pin",         handle:"4-odeurs-au-choix",                      variantId:44802558984391, price:"19,20 $",  img:"https://cdn.shopify.com/s/files/1/0567/8193/0695/files/12DC1AB0-FB0B-480B-970D-19A3DFD9FB18.jpg?v=1767643782",  tags:{ambiance:["se_detendre","concentrer"], notes:["boisee","fraiche"],            saison:["chalet_hiver","pluie_automne"], perso:["fan_plein_air","creative"]} },
  { id:"pacanes",           title:"Pacanes Grill\u00e9es",             handle:"pacane-grillee",                         variantId:46012476063943, price:"19,20 $",  img:"https://cdn.shopify.com/s/files/1/0567/8193/0695/files/BE70CF7F-908E-4E5F-9994-CC72B2734558.jpg?v=1767643453",  tags:{ambiance:["se_detendre","celebrer"],   notes:["gourmande"],                   saison:["chalet_hiver","pluie_automne"], perso:["creative","romantique"]} },
  { id:"gateau-fete",       title:"G\u00e2teau de f\u00eate",               handle:"gateau-de-fete",                         variantId:44158993334471, price:"39,99 $",  img:"https://cdn.shopify.com/s/files/1/0567/8193/0695/files/D8D71A1C-0CE3-445C-949F-0A71F318E29F.jpg?v=1721708808",  tags:{ambiance:["celebrer"],                 notes:["gourmande"],                   saison:["terrasse_ete","fleurs_printemps"], perso:["party_animal","boss"]} },
  { id:"mahogany",          title:"Mahogany Teakwood \u00c9pic\u00e9",       handle:"mahogany-teakwood-epice",                variantId:44576624607431, price:"24,00 $",  img:"https://cdn.shopify.com/s/files/1/0567/8193/0695/files/3CBFB26A-F2D8-4804-B3ED-5850F29E2BB2.jpg?v=1764559830",  tags:{ambiance:["se_detendre","concentrer"], notes:["boisee","sensuelle"],          saison:["chalet_hiver","pluie_automne"], perso:["boss","romantique"]} },
  { id:"foret-pluie",       title:"For\u00eat & Pluie",                 handle:"cedre-pluie",                            variantId:45535026938055, price:"24,00 $",  img:"https://cdn.shopify.com/s/files/1/0567/8193/0695/files/B777FF22-301C-481C-B65F-7B3C904C03E9.png?v=1726108819",  tags:{ambiance:["se_detendre","concentrer"], notes:["fraiche","boisee"],            saison:["pluie_automne","chalet_hiver"], perso:["fan_plein_air","creative"]} },
  { id:"odeur-signature",   title:"Odeur Signature",               handle:"odeur-signature",                        variantId:45464555192519, price:"42,00 $",  img:"https://cdn.shopify.com/s/files/1/0567/8193/0695/files/DFECF931-148E-4A9D-9AC8-640F7BA951D5.jpg?v=1756012316",  tags:{ambiance:["seduire","celebrer"],       notes:["sensuelle","fruitee"],         saison:["pluie_automne","chalet_hiver"], perso:["boss","romantique"]} },
  { id:"peches-creme",      title:"P\u00eaches & Cr\u00e8me",               handle:"peches-creme",                           variantId:44885911732423, price:"42,00 $",  img:"https://cdn.shopify.com/s/files/1/0567/8193/0695/files/Ok_Brunch_4_x_5_po_19.png?v=1744162185",               tags:{ambiance:["se_detendre","seduire"],    notes:["fruitee","gourmande","florale"],saison:["terrasse_ete","fleurs_printemps"], perso:["romantique","creative"]} },
  { id:"palo-santo",        title:"Palo Santo",                    handle:"palo-santo",                             variantId:44576625098951, price:"42,00 $",  img:"https://cdn.shopify.com/s/files/1/0567/8193/0695/files/Ok_Brunch_4_x_5_po_20_eecfbf76-a4e6-4e4c-98a0-7198d92fbf9b.svg?v=1759779462", tags:{ambiance:["se_detendre","concentrer"], notes:["boisee","sensuelle"],   saison:["pluie_automne","chalet_hiver"], perso:["fan_plein_air","boss"]} },
  { id:"cedre-cachemire",   title:"C\u00e8dre & Cachemire",            handle:"allume-moi-ppur-a",                      variantId:42669736067271, price:"24,00 $",  img:"https://cdn.shopify.com/s/files/1/0567/8193/0695/files/Ok_Brunch_4_x_5_po_7.png?v=1744160984",               tags:{ambiance:["seduire","concentrer"],     notes:["boisee","sensuelle","fraiche"],saison:["chalet_hiver","pluie_automne"], perso:["romantique","boss"]} }
];

// multi:true = plusieurs choix possibles, auto:true = avance automatiquement
var QUESTIONS = [
  {
    id: "ambiance",
    question: "Tu allumes une bougie pour\u2026",
    multi: false,
    auto: true,
    options: [
      { value:"se_detendre",  label:"Te d\u00e9tendre" },
      { value:"seduire",      label:"S\u00e9duire" },
      { value:"energiser",    label:"T\u2019\u00e9nergiser" },
      { value:"celebrer",     label:"C\u00e9l\u00e9brer" },
      { value:"concentrer",   label:"Te concentrer" }
    ]
  },
  {
    id: "notes",
    question: "Tu pr\u00e9f\u00e8res les odeurs\u2026",
    multi: true,
    auto: false,
    options: [
      { value:"fraiche",    label:"Fra\u00eeches" },
      { value:"florale",    label:"Florales" },
      { value:"gourmande",  label:"Gourmandes" },
      { value:"fruitee",    label:"Fruit\u00e9es" },
      { value:"boisee",     label:"Bois\u00e9es" },
      { value:"sensuelle",  label:"Sensuelles" }
    ]
  },
  {
    id: "saison",
    question: "Ton ambiance pr\u00e9f\u00e9r\u00e9e c\u2019est\u2026",
    multi: false,
    auto: true,
    options: [
      { value:"chalet_hiver",     label:"Chalet en hiver" },
      { value:"terrasse_ete",     label:"Terrasse en \u00e9t\u00e9" },
      { value:"pluie_automne",    label:"Pluie d\u2019automne" },
      { value:"fleurs_printemps", label:"Fleurs de printemps" }
    ]
  },
  {
    id: "perso",
    question: "Ton entourage te d\u00e9crirait comme la personne\u2026",
    multi: false,
    auto: true,
    options: [
      { value:"creative",      label:"Cr\u00e9ative" },
      { value:"romantique",    label:"Romantique" },
      { value:"boss",          label:"Boss" },
      { value:"fan_plein_air", label:"Fan de plein air" },
      { value:"party_animal",  label:"Party animal" }
    ]
  }
];

// Scoring: multi answers give partial points per match
function score(candle, answers) {
  var pts = 0;
  Object.keys(answers).forEach(function(q) {
    var val = answers[q];
    if (!candle.tags[q]) return;
    if (Array.isArray(val)) {
      val.forEach(function(v) {
        if (candle.tags[q].indexOf(v) !== -1) pts += 2;
      });
    } else {
      if (candle.tags[q].indexOf(val) !== -1) pts += 3;
    }
  });
  return pts;
}

function recommend(answers) {
  var scored = CANDLES.map(function(c) { return { candle: c, pts: score(c, answers) }; });
  scored.sort(function(a, b) { return b.pts - a.pts; });
  return scored.slice(0, 3).map(function(s) { return s.candle; });
}

var state = { step: 0, answers: {} };

function render(container) {
  if (state.step < QUESTIONS.length) {
    renderQuestion(container);
  } else if (state.step === QUESTIONS.length) {
    renderEmailGate(container);
  } else {
    renderResults(container);
  }
}

function renderQuestion(container) {
  var q = QUESTIONS[state.step];
  var progress = Math.round((state.step / QUESTIONS.length) * 100);
  var ans = state.answers[q.id];

  var html = '<div class="okbye-quiz-wrap">';
  html += '<div class="okbye-quiz-header">';
  html += '<p class="okbye-quiz-step">Question ' + (state.step + 1) + ' sur ' + QUESTIONS.length + '</p>';
  html += '<div class="okbye-quiz-bar"><div class="okbye-quiz-fill" style="width:' + progress + '%"></div></div>';
  html += '</div>';
  html += '<div class="okbye-quiz-body">';
  html += '<h2 class="okbye-quiz-q">' + q.question + '</h2>';

  if (q.multi) {
    html += '<p class="okbye-quiz-hint">Choisis une ou plusieurs r\u00e9ponses</p>';
  }

  html += '<div class="okbye-quiz-opts' + (q.multi ? ' okbye-quiz-opts--multi' : '') + '">';
  q.options.forEach(function(opt) {
    var sel = false;
    if (q.multi && Array.isArray(ans)) {
      sel = ans.indexOf(opt.value) !== -1;
    } else {
      sel = ans === opt.value;
    }
    html += '<button class="okbye-opt' + (sel ? ' okbye-opt--sel' : '') + '" data-q="' + q.id + '" data-v="' + opt.value + '" data-multi="' + (q.multi ? '1' : '0') + '" data-auto="' + (q.auto ? '1' : '0') + '">' + opt.label + '</button>';
  });
  html += '</div>';

  html += '<div class="okbye-quiz-nav">';
  if (state.step > 0) {
    html += '<button class="okbye-quiz-back">\u2190 Retour</button>';
  } else {
    html += '<span></span>';
  }

  if (q.multi) {
    var hasAns = Array.isArray(ans) && ans.length > 0;
    html += '<button class="okbye-quiz-next' + (hasAns ? '' : ' okbye-next--disabled') + '"' + (hasAns ? '' : ' disabled') + '>';
    html += state.step === QUESTIONS.length - 1 ? 'Voir mes bougies' : 'Suivant \u2192';
    html += '</button>';
  }

  html += '</div>';
  html += '</div></div>';

  container.innerHTML = html;

  container.querySelectorAll('.okbye-opt').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var isMulti = btn.dataset.multi === '1';
      var isAuto  = btn.dataset.auto === '1';
      var qid     = btn.dataset.q;
      var val     = btn.dataset.v;

      if (isMulti) {
        var cur = Array.isArray(state.answers[qid]) ? state.answers[qid].slice() : [];
        var idx = cur.indexOf(val);
        if (idx === -1) { cur.push(val); } else { cur.splice(idx, 1); }
        state.answers[qid] = cur;
        render(container);
      } else {
        state.answers[qid] = val;
        // Show selection first
        container.querySelectorAll('.okbye-opt').forEach(function(b) {
          b.classList.toggle('okbye-opt--sel', b.dataset.v === val);
        });
        if (isAuto) {
          setTimeout(function() {
            state.step++;
            render(container);
          }, 220);
        }
      }
    });
  });

  var nextBtn = container.querySelector('.okbye-quiz-next');
  if (nextBtn && !nextBtn.disabled) {
    nextBtn.addEventListener('click', function() {
      state.step++;
      render(container);
    });
  }

  var backBtn = container.querySelector('.okbye-quiz-back');
  if (backBtn) {
    backBtn.addEventListener('click', function() {
      state.step--;
      render(container);
    });
  }
}

function renderEmailGate(container) {
  var html = '<div class="okbye-quiz-wrap">';
  html += '<div class="okbye-quiz-header">';
  html += '<p class="okbye-quiz-step">Presque l\u00e0 !</p>';
  html += '<div class="okbye-quiz-bar"><div class="okbye-quiz-fill" style="width:90%"></div></div>';
  html += '</div>';
  html += '<div class="okbye-quiz-body">';
  html += '<h2 class="okbye-quiz-q">O\u00f9 envoyer tes r\u00e9sultats\u00a0?</h2>';
  html += '<p class="okbye-quiz-hint">Entre ton courriel pour d\u00e9couvrir tes bougies id\u00e9ales.</p>';
  html += '<div class="okbye-email-wrap">';
  html += '<input type="email" class="okbye-email-input" id="okbye-email" placeholder="ton@courriel.com" autocomplete="email">';
  html += '<p class="okbye-email-note">On ne spam jamais. Promis.</p>';
  html += '</div>';
  html += '<div class="okbye-quiz-nav">';
  html += '<button class="okbye-quiz-back">\u2190 Retour</button>';
  html += '<button class="okbye-quiz-next okbye-next--disabled" id="okbye-email-submit" disabled>Voir mes r\u00e9sultats \u2192</button>';
  html += '</div>';
  html += '</div></div>';

  container.innerHTML = html;

  var input = container.querySelector('#okbye-email');
  var submitBtn = container.querySelector('#okbye-email-submit');

  input.addEventListener('input', function() {
    var valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value.trim());
    submitBtn.disabled = !valid;
    submitBtn.classList.toggle('okbye-next--disabled', !valid);
  });

  submitBtn.addEventListener('click', function() {
    if (submitBtn.disabled) return;
    state.email = input.value.trim();
    // Shopify natif : abonne au marketing + tag quiz-odeur
    try {
      fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: [
          'form_type=customer',
          'utf8=%E2%9C%93',
          'customer[email]=' + encodeURIComponent(state.email),
          'customer[accepts_marketing]=true',
          'contact[body]=Quiz+odeur+Ok+Bye',
          'contact[tags]=quiz-odeur'
        ].join('&')
      });
    } catch(e) {}
    state.step = QUESTIONS.length + 1;
    renderResults(container);
  });

  container.querySelector('.okbye-quiz-back').addEventListener('click', function() {
    state.step = QUESTIONS.length - 1;
    render(container);
  });
}

function renderResults(container) {
  var results = recommend(state.answers);

  var html = '<div class="okbye-quiz-wrap okbye-quiz-wrap--results">';
  html += '<div class="okbye-quiz-header">';
  html += '<p class="okbye-quiz-step">R\u00e9sultats</p>';
  html += '<div class="okbye-quiz-bar"><div class="okbye-quiz-fill okbye-quiz-fill--done" style="width:100%"></div></div>';
  html += '</div>';
  html += '<div class="okbye-quiz-body">';
  html += '<h2 class="okbye-quiz-q">Tes bougies faites pour toi</h2>';
  html += '<p class="okbye-quiz-hint">On a trouv\u00e9 ton match olfactif parfait&nbsp;!</p>';

  html += '<div class="okbye-results-grid">';
  results.forEach(function(c, i) {
    html += '<div class="okbye-result-card">';
    if (i === 0) html += '<div class="okbye-result-badge">Coup de c\u0153ur</div>';
    html += '<img src="' + c.img + '" alt="' + c.title + '" class="okbye-result-img" loading="lazy">';
    html += '<div class="okbye-result-info">';
    html += '<p class="okbye-result-title">' + c.title + '</p>';
    html += '<p class="okbye-result-price">' + c.price + '</p>';
    html += '</div>';
    html += '<button class="okbye-result-atc" data-variant="' + c.variantId + '">Ajouter au panier</button>';
    html += '<a href="/products/' + c.handle + '" class="okbye-result-link">Voir le produit</a>';
    html += '</div>';
  });
  html += '</div>';

  html += '<button class="okbye-quiz-restart">\u2190 Recommencer le quiz</button>';
  html += '</div></div>';

  container.innerHTML = html;

  container.querySelectorAll('.okbye-result-atc').forEach(function(btn) {
    btn.addEventListener('click', async function() {
      var variantId = parseInt(btn.dataset.variant);
      btn.textContent = '...';
      btn.disabled = true;
      try {
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        if (res.ok) {
          btn.textContent = 'Ajout\u00e9e !';
          btn.classList.add('okbye-atc--done');
          document.dispatchEvent(new CustomEvent('cart:updated'));
        } else {
          btn.textContent = 'Erreur';
          btn.disabled = false;
        }
      } catch(e) {
        btn.textContent = 'Erreur';
        btn.disabled = false;
      }
    });
  });

  container.querySelector('.okbye-quiz-restart').addEventListener('click', function() {
    state = { step: 0, answers: {}, email: null };
    render(container);
  });
}

function injectStyles() {
  if (document.getElementById('okbye-quiz-styles')) return;
  var s = document.createElement('style');
  s.id = 'okbye-quiz-styles';
  s.textContent = [
    '.okbye-quiz-wrap{max-width:640px;margin:0 auto;padding:28px 16px;font-family:inherit}',
    '.okbye-quiz-header{margin-bottom:24px}',
    '.okbye-quiz-step{font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.12em;color:#aaa;margin:0 0 10px}',
    '.okbye-quiz-bar{height:3px;background:#EDE0D8;border-radius:99px;overflow:hidden}',
    '.okbye-quiz-fill{height:100%;background:linear-gradient(90deg,#1A1A1A,#555);border-radius:99px;transition:width .4s ease}',
    '.okbye-quiz-fill--done{background:linear-gradient(90deg,#3A8C55,#52C47A)}',
    '.okbye-quiz-body{text-align:center}',
    '.okbye-quiz-q{font-size:clamp(17px,2.5vw,24px);font-weight:800;color:#1A1A1A;margin:0 0 6px;line-height:1.3}',
    '.okbye-quiz-hint{font-size:12px;color:#aaa;margin:0 0 20px}',
    '.okbye-quiz-opts{display:flex;flex-wrap:wrap;gap:8px;justify-content:center;margin:20px 0 28px}',
    '.okbye-opt{padding:11px 22px;border:1.5px solid #E8E0D8;border-radius:50px;background:#fff;font-size:14px;font-weight:600;color:#1A1A1A;cursor:pointer;font-family:inherit;transition:all .15s ease;white-space:nowrap}',
    '.okbye-opt:hover{border-color:#1A1A1A}',
    '.okbye-opt--sel{border-color:#1A1A1A;background:#1A1A1A;color:#fff}',
    '.okbye-quiz-nav{display:flex;justify-content:space-between;align-items:center}',
    '.okbye-quiz-back{background:none;border:none;font-size:13px;color:#aaa;cursor:pointer;font-family:inherit;padding:8px 0}',
    '.okbye-quiz-back:hover{color:#1A1A1A}',
    '.okbye-quiz-next{padding:12px 28px;background:#1A1A1A;color:#fff;border:none;border-radius:10px;font-size:13px;font-weight:800;text-transform:uppercase;letter-spacing:.05em;cursor:pointer;font-family:inherit}',
    '.okbye-quiz-next:hover:not(:disabled){background:#333}',
    '.okbye-next--disabled{opacity:.3;cursor:not-allowed}',
    '.okbye-results-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:12px;margin:20px 0 24px;text-align:left;align-items:stretch}',
    '@media(max-width:480px){.okbye-results-grid{grid-template-columns:1fr 1fr}.okbye-results-grid .okbye-result-card:first-child{grid-column:1/-1}}',
    '.okbye-result-card{border:1.5px solid #E8E0D8;border-radius:12px;overflow:hidden;background:#fff;display:flex;flex-direction:column}',
    '.okbye-result-card:first-child{border-color:#1A1A1A}',
    '.okbye-result-badge{background:#1A1A1A;color:#fff;font-size:9px;font-weight:800;text-transform:uppercase;letter-spacing:.12em;padding:5px 10px;text-align:center}',
    '.okbye-result-img{width:100%;height:160px;object-fit:cover;object-position:center;display:block;flex-shrink:0}',
    '.okbye-result-info{padding:10px 10px 2px;flex:1}',
    '.okbye-result-title{font-size:12px;font-weight:700;color:#1A1A1A;margin:0 0 2px;line-height:1.3}',
    '.okbye-result-price{font-size:11px;color:#aaa;margin:0}',
    '.okbye-result-atc{display:block;width:calc(100% - 20px);margin:8px 10px 0;padding:10px;background:#1A1A1A;color:#fff;border:none;border-radius:7px;font-size:11px;font-weight:800;text-transform:uppercase;letter-spacing:.05em;cursor:pointer;font-family:inherit}',
    '.okbye-result-atc:hover:not(:disabled){background:#333}',
    '.okbye-atc--done{background:#3A8C55 !important}',
    '.okbye-result-link{display:block;text-align:center;font-size:10px;color:#bbb;text-decoration:underline;padding:6px 10px 10px;font-family:inherit}',
    '.okbye-result-link:hover{color:#666}',
    '.okbye-quiz-restart{background:none;border:1.5px solid #E8E0D8;border-radius:8px;padding:10px 20px;font-size:12px;color:#aaa;cursor:pointer;font-family:inherit;margin-top:4px}',
    '.okbye-quiz-restart:hover{border-color:#1A1A1A;color:#1A1A1A}',
    '.okbye-email-wrap{margin:20px 0 28px}',
    '.okbye-email-input{width:100%;max-width:340px;padding:13px 16px;border:1.5px solid #E8E0D8;border-radius:10px;font-size:15px;font-family:inherit;color:#1A1A1A;outline:none;box-sizing:border-box;transition:border-color .15s}',
    '.okbye-email-input:focus{border-color:#1A1A1A}',
    '.okbye-email-note{font-size:11px;color:#bbb;margin:8px 0 0;text-align:center}'
  ].join('');
  document.head.appendChild(s);
}

function mountSingle(el) {
  state = { step: 0, answers: {}, email: null };
  render(el);
}

function mount() {
  injectStyles();
  document.querySelectorAll('[data-okbye-quiz]').forEach(function(el) {
    if (el.closest('.okbye-qt-panel') && !el.closest('.okbye-qt-panel--open')) return;
    mountSingle(el);
  });
}

window._okbyeQuizMount = function(el) {
  if (!el) return;
  injectStyles();
  mountSingle(el);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mount);
} else {
  mount();
}

})();